"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class VerticalLayout1Module {
}
exports.VerticalLayout1Module = VerticalLayout1Module;
